import ProviderUtilizationPage from './pages/provider';
import RecordsImportPage from './pages/records-import';
import VCCProviderMetricsPage from './pages/vcc';

import {
    BarChartOutlined,
    DashboardOutlined,
    SupervisorAccount,
    WbIncandescentOutlined,
    WorkOutlineOutlined
} from '@material-ui/icons';


const routes = [
    DashboardOutlined,
    {
        mainNavName: 'Platform Insight',
        path: '/insights',
        environments: ['develop', 'test', 'staging', 'production'],
        icon: WbIncandescentOutlined,
        children: [
            {
                mainNavName: 'Nightly P360 import',
                path: '/insights/records-import',
                exact: true,
                environments: ['develop', 'test', 'staging', 'production'],
                element: RecordsImportPage,
                icon: BarChartOutlined
            },
            {
                mainNavName: 'Provider Utilization',
                path: '/insights/provider-utilization',
                exact: true,
                environments: ['develop', 'test', 'staging', 'production'],
                element: ProviderUtilizationPage,
                icon: WorkOutlineOutlined
            },
            {
                mainNavName: 'Oncologist Metrics',
                path: '/insights/vcc-provider-metrics',
                exact: true,
                environments: ['develop', 'test', 'staging', 'production'],
                element: VCCProviderMetricsPage,
                icon: SupervisorAccount
            }
        ]
    }
];


export default routes;